// Generated by CoffeeScript 2.7.0
var Admin__CascadedSelectsController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import GenerateCascadedSelectsSidebar from 'trunks/vue/admin/compositions/cascaded_selects/cascaded_selects_sidebar.js';

import CascadedSelectContainer from 'trunks/vue/admin/compositions/cascaded_selects/cascade_select_content/cascaded_select_container.js';

export default Admin__CascadedSelectsController = (function() {
  class Admin__CascadedSelectsController extends Skylark.App.BaseController {
    index() {
      return this._generateCascadedSelectsSidebar('');
    }

    show() {
      var id;
      id = this.getIds()[0];
      this._generateCascadedSelectsSidebar(id);
      return Skylark.Libs.Ajax.get(`/admin/cascaded_selects/${id}`, {
        responseType: 'json',
        success: function(data) {
          return new CascadedSelectContainer({
            el: DomMaster.find("#cascaded_selects_container").node,
            propsData: {
              initialCascadedSelect: data
            }
          });
        }
      });
    }

  };

  Admin__CascadedSelectsController.include(GenerateMorePopover);

  Admin__CascadedSelectsController.include(GenerateCascadedSelectsSidebar);

  return Admin__CascadedSelectsController;

}).call(this);
